import React, { useState, useEffect } from "react";
import '../styles/Header.css';

import AuthModal from "./AuthModal"; // Импортируем модальное окно
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaRegUserCircle, FaChevronDown } from 'react-icons/fa';
import Cookies from "js-cookie";
import { useAuth } from "../context/AuthContext";
import { usePayment } from "../context/PaymentContext";

import { getApiUrl } from "../utils/config";
import { formatBalanceLocale } from "../utils/numberFormat";
const API_URL = getApiUrl();

const Header = () => {
    const { t, i18n } = useTranslation();
    const [showAuthModal, setShowAuthModal] = useState(false);

    const { isAuth, isAdmin, checkAuth } = useAuth();
    const { openPaymentModal, getCurrentBalance, selectedCurrency, openGlobalCurrencyDropdown } = usePayment();

    const [isLogintype, setIsLogin] = useState(true); // 'login' или 'register'
    const navigate = useNavigate();



    useEffect(() => {
        FetchUrlParams();

        // Глобальный слушатель для открытия модалки регистрации/логина из других компонентов
        const handler = (e) => {
            const mode = e?.detail?.mode === 'register' ? false : true; // false => регистрация
            setIsLogin(mode);
            setShowAuthModal(true);
        };
        window.addEventListener('open-auth-modal', handler);
        return () => window.removeEventListener('open-auth-modal', handler);
    }, []);





    const FetchUrlParams = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const refId = urlParams.get("ref");

        if (refId && !Cookies.get("ref_id")) {
            Cookies.set("ref_id", refId, { expires: 7, path: "/" });
            console.log(`🔗 [HEADER] Реферальная ссылка сохранена в cookies: ref_id=${refId}`);
        } else if (refId && Cookies.get("ref_id")) {
            console.log(`ℹ️ [HEADER] Реферальная ссылка уже сохранена в cookies: ref_id=${Cookies.get("ref_id")}`);
        }
    };

    // Функция для получения символа валюты
    const getCurrencySymbol = (currency) => {
        switch (currency) {
            case 'USD':
                return '$';
            case 'RUB':
                return '₽';
            case 'BRL':
                return 'R$';
            case 'USDT':
                return '₮';
            case 'EUR':
                return '€';
            default:
                return '$';
        }
    };

    return (
        <>
            <header className="header">
                <div className="header-content">
                    <div className="header-left">
                        <Link to="/">
                            <img
                                src="/assets/headerlogo.webp"
                                alt="Logo"
                                className="logo"
                            />
                        </Link>
                    </div>

                    <div className="header-right">
                        {!isAuth ? (
                            <>
                                <button className="btn sign-in" onClick={() => { setIsLogin(true); setShowAuthModal(true); }}> {t("header.signIn")}  </button>
                                <button className="btn sign-up glow-blue" onClick={() => { setIsLogin(false); setShowAuthModal(true); }}>{t("header.signUp")}</button>
                            </>
                        ) : (
                            <>
                                <div className="header-balance">
                                    <div
                                        className="header-balance-link"
                                        onClick={(e) => {
                                            console.log('🖱️ Header balance clicked!');
                                            console.log('Event details:', {
                                                target: e.target,
                                                currentTarget: e.currentTarget,
                                                type: e.type,
                                                bubbles: e.bubbles
                                            });
                                            console.log('openGlobalCurrencyDropdown available:', !!openGlobalCurrencyDropdown);

                                            e.preventDefault();
                                            e.stopPropagation();

                                            if (openGlobalCurrencyDropdown) {
                                                console.log('🔄 Calling openGlobalCurrencyDropdown...');
                                                openGlobalCurrencyDropdown(e.currentTarget);
                                            } else {
                                                console.error('❌ openGlobalCurrencyDropdown is not available');
                                            }
                                        }}
                                        onMouseDown={(e) => {
                                            console.log('🖱️ Header balance mousedown');
                                        }}
                                        onMouseUp={(e) => {
                                            console.log('🖱️ Header balance mouseup');
                                        }}
                                        style={{
                                            cursor: 'pointer',
                                            userSelect: 'none',
                                            pointerEvents: 'auto',
                                            position: 'relative',
                                            zIndex: 1002
                                        }}
                                    >
                                        <div className="header-balance-inner">
                                            <div className="header-balance-amount">
                                                {formatBalanceLocale(getCurrentBalance())}
                                            </div>

                                            <div className="currency-symbol">
                                                {getCurrencySymbol(selectedCurrency)}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <button className="btn sign-up glow-blue" onClick={() => openPaymentModal({ type: "deposit" })}> {t("header.topup")} </button>

                            </>
                        )}
                    </div>
                </div>

                {showAuthModal && (
                    <AuthModal onClose={() => setShowAuthModal(false)} isLoginType={isLogintype} onLoginSuccess={checkAuth} />
                )}
            </header>

            {isAdmin && 1 > 2 && (
                <header className="header">
                    <div className="header-content">
                        <div className="header-left">
                        </div>
                        <div className="header-right">
                            <Link to="/prefs" className="btn sign-in admin-btn">Админ</Link>
                        </div>
                    </div>
                </header>
            )}
        </>
    );
};

export default Header;
